import { client } from "./client";

const ROUTES = {
  webhook: companyId => `/webhook/?companydb_id=${companyId}`,
  create: () => `/webhook/`,
  update: webhook_id => `/webhook/${webhook_id}/`,
};

export const webhook = {
  getData: ({companyId}) => {
    return client.get(ROUTES.webhook(companyId));
  },
  create: ({form}) => {
    return client.post(ROUTES.create(), form);
  },
  update: ({webhookId, form}) => {
    return client.patch(ROUTES.update(webhookId), form);
  },
};